import React from 'react'
import "./SearchBy.css"

//AntDesign import
import { Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const SearchBy = ({ searchTitle, elementSize, options, handleSelectProduct, value }) => {
  const onChangeHandler = (value) => {
    const selectedItem = options.find((item) => item.value === value);
    if (selectedItem) {
      handleSelectProduct(selectedItem);
    } else {
      handleSelectProduct(null);
    }
  }
  return (
    <div className="inventory-search-by">
      {searchTitle && <p className="inventory-search-title">{searchTitle}</p>}
      <Select
        style={{ width: elementSize || 150 }}
        allowClear
        value={value || null}
        options={options || []}
        placeholder="Search By"
        onChange={(e) => onChangeHandler(e)}
      />
      {value?.name === "orderNumber" && (
        <Tooltip title="Supports non-inventory and newly created inventory orders only.">
          <InfoCircleOutlined className="order-number-info-icon" />
        </Tooltip>
      )}
    </div>
  );
}

export default SearchBy